import { IconArrowsArrowLeft } from '@doltech/icons/IconArrowsArrowLeft';
import { IconArrowsArrowRight } from '@doltech/icons/IconArrowsArrowRight';
import { IconUserEyeShow } from '@doltech/icons/IconUserEyeShow';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';

import { RequiredAuthFake } from '../../../../../Auth/RequiredAuthFake';
import { Button } from '../../../../../ButtonV2/ButtonV2';
import { colorsV2 } from '../../../../../colors-v2';
import { useDoExerciseProgressStore } from '../../../../shared-components/Exercise/do-exercise-progress-store.store';
import { useDoExerciseProgressContext } from '../../../../shared-components/Exercise/DoExerciseProgressContext';
import { useExerciseQuizDoTestStore } from '../../store/exercise-quiz-do-test.store';

const Main = styled.div`
  display: grid;
  align-items: center;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  gap: 10px;
  justify-content: flex-end;

  .icon-eye {
    path {
      fill: ${colorsV2.white100};
    }
  }
`;

export const DoTestActions = observer((props: RenderElementProps) => {
  const { element } = props;
  const store = useExerciseQuizDoTestStore();
  const currentQuestion = element?.children?.[store.currentQuizIndex];
  const progressStore = useDoExerciseProgressStore();
  const { pageId } = useDoExerciseProgressContext();
  const renderSubmitButton = React.useCallback(() => {
    const check = async () => {
      if (currentQuestion?.id) {
        const data = await store.check({ pageId, questionId: currentQuestion?.id });
        if (data) {
          progressStore.init([data]);
        }
      }
    };
    const currentAnswer = store.userAnswers.get(currentQuestion?.id);
    const isSubmitted = currentAnswer?.submitted;

    if (isSubmitted) {
      return store.currentQuizIndex >= (element?.children.length - 1 || 0) ? (
        <Button.Primary
          className="quizz-action-btn"
          onClick={async () => {
            store.resetQuizIndex();
          }}
          iconRight={<IconUserEyeShow className="icon-eye" />}
        >
          Xem lại
        </Button.Primary>
      ) : (
        <Button.Primary
          className="quizz-action-btn"
          onClick={async () => {
            store.nextQuizIndex();
          }}
          iconRight={<IconArrowsArrowRight />}
        >
          Câu tiếp theo
        </Button.Primary>
      );
    }
    return (
      <RequiredAuthFake
        title="Chức năng này chỉ dành riêng cho thành viên của dolacademy.vn"
        onLoginSuccess={check}
      >
        {({ forceLoginToProceedAction }) => (
          <Button.Primary
            disabled={!store.canSubmit({ questionId: currentQuestion?.id })}
            className="quizz-action-btn"
            onClick={() => {
              forceLoginToProceedAction(check);
            }}
          >
            Check đáp án
          </Button.Primary>
        )}
      </RequiredAuthFake>
    );
  }, [currentQuestion?.id, element?.children.length, pageId, progressStore, store]);

  return (
    <Main>
      {store.currentQuizIndex > 0 && (
        <Button.Secondary
          onClick={async () => {
            store.prevQuizIndex();
          }}
          iconLeft={<IconArrowsArrowLeft />}
          variant="outline-white"
          className="quizz-action-btn"
        />
      )}

      {renderSubmitButton()}
    </Main>
  );
});
